import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Select } from '@components/core-ui/form-elements/Select';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { SubscriptionsService } from 'app/API';
import { useState } from 'react';
import { Wrapper } from './styles/Wrapper';
import { TProps } from './types/TProps';

export const EditLicenseTranscriptUnlockTypeModal = ({
  baId,
  licenseId,
  initialValue,
  onCancel,
  onSuccess,
}: TProps) => {
  const { call } = useAPI();
  const [value, setValue] = useState(initialValue);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const values = [
    { label: 'ASOne Enhanced', value: 'ASONE_ENHANCED' },
    { label: 'Session Text', value: 'SESSION_TEXT' },
    { label: 'Choose', value: 'CHOOSE' },
  ];

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await call(
      SubscriptionsService.updateLicenseTranscriptUnlockType({
        baId,
        licenseId,
        requestBody: { transcriptUnlockType: value },
      }),
    );
    setIsSubmitting(false);
    onSuccess();
    onCancel();
  };

  return (
    <Wrapper>
      <ModalWrapper width="487px" overflow="visible">
        {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
        <ModalTitle>Update Transcript Unlock Type</ModalTitle>

        <Select
          name="value"
          label="Transcript Unlock Type"
          className="form-autocomplete"
          value={value}
          onChange={(_, value) => setValue(value)}
          options={values}
          required={false}
        />

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit}>Update</Button>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};
